const recurTypes = {
  NO_REPEAT: 'NO_REPEAT',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY'
};

export default recurTypes;